import { render, staticRenderFns } from "./TituloPagina.vue?vue&type=template&id=1d6c46d2&scoped=true&"
import script from "./TituloPagina.vue?vue&type=script&lang=js&"
export * from "./TituloPagina.vue?vue&type=script&lang=js&"
import style0 from "./TituloPagina.vue?vue&type=style&index=0&id=1d6c46d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6c46d2",
  null
  
)

export default component.exports